/**
 * Anfitrión por defecto de Grups (GTK-802).
 *
 * Este objeto es lo que el BO escribe en `event_hosts` cada vez que crea un evento
 * (EventForm: alta simple y una vez por fecha en las series recurrentes), así que su
 * contenido NO es sólo de render: termina en la base y lo lee también la app mobile.
 *
 * Hasta GTK-802 `hostImageBase64` eran 15.728 caracteres de un JPEG 360x240 inline.
 * Eso significaba ~15,7 KB de texto por fila de `event_hosts` —una serie semanal de 52
 * fechas escribía 52 copias del mismo JPEG— y además viajaba en el listado de eventos
 * (`buildGetEventsSelectSql` lo selecciona), donde nadie lo renderiza: hasta ~780 KB por
 * página de 50. Ahora se referencia por URL.
 *
 * Contrato (el mismo que ya usan las portadas de evento desde que existe el upload a S3):
 *   imageFormat = "<URL absoluta>#"   imageBase64 = ""
 * - `getEventImageSrc` devuelve la URL tal cual si arranca con http(s).
 * - La app mobile (`ImageBase64`) resuelve `{ uri: imageFormat }` por el mismo camino.
 * - El "#" final es para los binarios de la app anteriores a 4.8.1, que concatenan
 *   `imageFormat + "," + imageBase64`: el fragmento se come la coma y la imagen carga
 *   igual. Como la app no tiene OTA (no hay expo-updates), ese JS queda congelado por
 *   build y no se puede arreglar desde acá. No saques el "#" sin confirmar antes la
 *   versión mínima forzada que sirve /system.
 *
 * El asset vive en S3, en el mismo bucket que las portadas, bajo un prefijo propio
 * `hosts/default/`. El archivo fuente está versionado en `public/assets/images/default-host.png`
 * (256x256, PNG-8 paletizado, 3.695 bytes) junto con el SVG del que se generó; subirlo es
 * un paso único por ambiente, documentado en `scripts/gtk-802/README.md`.
 */

/**
 * URL del asset por defecto, por ambiente (dev/qa comparten bucket con prod separado).
 * El fallback apunta al bucket de dev a propósito: si la variable falta, es preferible
 * una imagen de dev visible a un `undefined` que rompa el alta de eventos.
 */
const DEFAULT_HOST_IMAGE_URL =
  process.env.REACT_APP_DEFAULT_HOST_IMAGE_URL ||
  "https://grups-event-assets-dev.s3.sa-east-1.amazonaws.com/hosts/default/anfitrion-grups.png";

export const DefaultHost = {
  hostEmail: "anfitrion@grups.app",
  hostDescription: "",
  /** URL + "#", ver el contrato de arriba. */
  hostImageFormat: `${DEFAULT_HOST_IMAGE_URL}#`,
  /** Vacío: el asset ya no viaja inline. */
  hostImageBase64: "",
};
